import { createFileRoute } from '@tanstack/react-router'

import sourceRaw from '#/content/support/terms-of-service.md?raw'
import sourceUrl from '#/content/support/terms-of-service.md?url'
import { Article } from './-components/Article.js'

/** Route for Tempo's Terms of Service. */
export const Route = createFileRoute('/support/terms-of-service')({
  component: TermsOfServicePage,
  // Server reads the bundled markdown directly (no client-side bundle cost
  // because the `?raw` import is tree-shaken via `import.meta.env.SSR`).
  // Client fetches the hashed `.md` static asset; the loader fires when the
  // route matches, in parallel with mount and (when preloaded) chunk download.
  loader: async () => {
    if (import.meta.env.SSR) return sourceRaw
    const response = await fetch(sourceUrl)
    if (!response.ok) throw new Error(`Failed to load Terms of Service (${response.status})`)
    return response.text()
  },
  head: () => ({
    links: [{ href: 'https://wallet.tempo.xyz/support/terms-of-service', rel: 'canonical' }],
    meta: [
      { title: 'Terms of Service | Tempo Wallet' },
      { content: 'Terms of Service for Tempo.', name: 'description' },
    ],
  }),
})

function TermsOfServicePage() {
  return <Article slug="terms-of-service" source={Route.useLoaderData()} />
}
